import { Navigate, RouteObject } from "react-router-dom";
import NotFoundScreen from "./404";
import { AuthenticationRoutes } from "./Authentication";
import AmeelioLoggedOutScreen from "./Authentication/AmeelioLoggedOutScreen";
import AmeelioLoginPage from "./Authentication/AmeelioLogin";
import LogoutScreen from "./Authentication/LogoutScreen";
import CallRoutes from "./Call/routes";
import { ContactsRoutes } from "./Contacts";
import EventsRoutes from "./Events/routes";
import { HomeRoutes } from "./Home";
import { MessagesRoutes } from "./Messages";
import { NotificationsRoutes } from "./Notifications";
import { OrganizationsRoutes } from "./Organization";
import { SettingsRoutes } from "./Settings";
import { SupportRoutes } from "./Support";
import { ToolboxRoutes } from "./Toolbox";
import { ToolboxRoutesOld } from "./Toolbox/routes";
import TwilioCallRoutes from "./TwilioCall/routes";
import VoiceCallRoutes from "./VoiceCall/routes";

const toolbox = window.location.host === import.meta.env.VITE_TOOLBOX_HOST;

const NamespaceRedirect = () => {
  const { pathname, search, hash } = window.location;
  const nextPath = pathname.startsWith("/toolbox")
    ? pathname.slice("/toolbox".length) || "/"
    : pathname;
  return <Navigate to={`${nextPath}${search}${hash}`} replace />;
};

const appRoutes: RouteObject[] = toolbox
  ? [
      {
        path: "*",
        element: <NotFoundScreen />,
      },
      {
        path: "toolbox/*",
        element: <NamespaceRedirect />,
      },
      {
        path: "login/ameelio",
        element: <AmeelioLoginPage />,
      },
      {
        path: "logged-out",
        element: <AmeelioLoggedOutScreen />,
      },
      {
        path: "logout",
        element: <LogoutScreen />,
      },
      ToolboxRoutes,
    ]
  : [
      {
        path: "*",
        element: <NotFoundScreen />,
      },
      HomeRoutes,
      AuthenticationRoutes,
      SettingsRoutes,
      OrganizationsRoutes,
      EventsRoutes,
      MessagesRoutes,
      CallRoutes,
      TwilioCallRoutes,
      VoiceCallRoutes,
      ContactsRoutes,
      NotificationsRoutes,
      SupportRoutes,
      ToolboxRoutesOld, // deprecated
    ];

export default appRoutes;
